import {createContext, useContext} from 'react'

export const ContactModalContext = createContext<{
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
}>({
  isOpen: false,
  setOpen: () => {}
})

export const useContactModalContext = () => {
  return useContext(ContactModalContext)
}
